module.exports = __webpack_public_path__ + "media/images/plus-icon-fb7131d9df0fa07a01b73ba766c08112.svg";